<template>
  <pack>
    <el-form label-width="100px" label-position="left">
      <el-form-item label="线上版本">{{onlineVer}}</el-form-item>
      <el-form-item label="代码模板">
        <el-select @change="initExtJson" v-model="code_info.template_id" placeholder="请选择">
          <el-option
            v-for="item in template_list"
            :key="item.template_id"
            :label="item.user_version"
            v-model="item.template_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="ext_json">
        <el-input type="textarea" :row="8" placeholder="请输入ext_json" v-model="ext_json"></el-input>
      </el-form-item>
    </el-form>
    <zt-button type="primary" @click="upload">上传</zt-button>
    <zt-button type="primary" @click="getQrcode">获取体验二维码</zt-button>
    <zt-button type="primary" @click="submitPrivacy">提交隐私政策</zt-button>
    <zt-button type="primary" @click="submitAudit">提交审核</zt-button>
    <zt-button type="primary" @click="unDocodeaudit">撤回审核</zt-button>
    <zt-button type="primary" @click="releaseProgram">发布</zt-button>
    <div class="qrcode-box" v-if="qrcode">
      <img :src="qrcode" alt />
      <br />
      <span>体验版二维码</span>
    </div>
  </pack>
</template>

<script>
import { admin_plugin_wxapp_api, admin_plugin_wxapp_code, admin_plugin_privacysetting } from '@/api/program';


export default {
  name: 'versonManage',
  props: {
    editList: Array,
    active: [String, Number],
  },
  data: () => ({
    template_list: [],
    code_info: {},
    qrcode: '',
    ext_json: '',
  }),
  computed: {
    // ext_json:vm=>{
    //   let temJson = {
    //     extEnable:true,
    //     extAppid:vm.editList[0].authorizer_appid,
    //     directCommit:false,
    //     ext:{
    //       now_version:vm.code_info.template_id
    //     }
    //   }
    // }
    onlineVer() {
      return this.editList[0].now_version ? this.editList[0].now_version : '无线上版本'
    },
  },
  methods: {
    initExtJson() {
      let version = '';
      this.template_list.map((arr) => {
        if (arr.template_id == this.code_info.template_id) {
          version = arr.user_version;
          this.code_info.user_version = arr.user_version;
          this.code_info.user_desc = arr.user_desc;
        }
      });
      let temJson = {
        extEnable: true,
        extAppid: this.editList[0].authorizer_appid,
        directCommit: false,
        ext: {
          now_version: version,
        },
      };

      this.ext_json = JSON.stringify(temJson);
    },
    getCodeInfo() {
      admin_plugin_wxapp_code({
        wxapp_id: this.editList[0].id,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.code_info = data.code_info;
          this.ext_json = data.code_info.ext_json;
          if (data.code_info.ext_json == '') {
            this.initExtJson();
          }
        } else {
          this.$message.error(data.error_massage);
        }
      });
    },
    getTemplateList() {
      let params = {
        id: this.editList[0].id,
        url:
          'https://api.weixin.qq.com/wxa/gettemplatelist?access_token=COMPONENT_ACCESS_TOKEN',
      };
      admin_plugin_wxapp_api(params).then(({ data }) => {
        if (data.error_code == 0 && data.result.errcode == 0) {
          // 版本号排序
          this.template_list = data.result.template_list.sort((a, b) => {
            let i = 0;
            const arr1 = a.user_version.split('.');
            const arr2 = b.user_version.split('.');

            // eslint-disable-next-line no-constant-condition
            while (true) {
              const s1 = arr1[i];
              const s2 = arr2[i++];

              if (s1 === undefined || s2 === undefined) {
                return arr2.length - arr1.length;
              }

              if (s1 === s2) continue;

              return s2 - s1;
            }
          });
        } else if (data.error_code) {
          this.$message.error(data.error_message);
        } else {
          this.$message.error(data.result.errmsg);
        }
      });
    },
    getQrcode() {
      let params = {
        id: this.editList[0].id,
        url:
          'https://api.weixin.qq.com/wxa/get_qrcode?access_token=ACCESS_TOKEN',
      };
      admin_plugin_wxapp_api(params).then(({ data }) => {
        if (data.error_code == 0 && !data.result.errcode) {
          this.qrcode = data.result.qrcode;
        } else if (data.error_code) {
          this.$message.error(data.error_message);
        } else {
          this.$message.error(data.result.errmsg);
        }
      });
    },
    upload() {
      const { code_info } = this;
      let params = {
        id: this.editList[0].id,
        url: 'https://api.weixin.qq.com/wxa/commit?access_token=ACCESS_TOKEN',
        data: JSON.stringify({
          template_id: code_info.template_id,
          ext_json: this.ext_json,
          user_version: code_info.user_version,
          user_desc: code_info.user_desc,
        }),
      };
      this.$confirm('确定上传代码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.success('上传代码成功');
            } else if (data.error_code) {
              this.$message.error(data.error_massage);
            } else {
              this.$message.error(data.result.errmsg);
            }
            // 刷新数据
            this.getCodeInfo();
            this.getQrcode();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitPrivacy() {
      let params = {
        id: this.editList[0].id,
      };
      this.$confirm('确定提交隐私政策?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_privacysetting(params).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success('提交隐私政策成功');
            } else {
              this.$message.error(data.error_message)
            }
            // 刷新数据
            this.getCodeInfo();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitAudit() {
      let params = {
        id: this.editList[0].id,
        url:
          'https://api.weixin.qq.com/wxa/submit_audit?access_token=ACCESS_TOKEN',
        data: JSON.stringify({
          test: 1,
          // version_desc:code_info.user_desc,
        }),
      };
      this.$confirm('确定提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.success('提交审核成功');
            } else if (data.error_code) {
              this.$message.error(data.error_message);
            } else {
              this.$message.error(data.result.errmsg);
            }
            // 刷新数据
            this.getCodeInfo();
            this.getQrcode();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    unDocodeaudit() {
      let params = {
        id: this.editList[0].id,
        url:
          'https://api.weixin.qq.com/wxa/undocodeaudit?access_token=ACCESS_TOKEN',
      };
      this.$confirm('确定撤回审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.success('撤回审核成功');
            } else if (data.error_code) {
              this.$message.error(data.error_massage);
            } else {
              this.$message.error(data.result.errmsg);
            }
            // 刷新数据
            this.getCodeInfo();
            this.getQrcode();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    releaseProgram() {
      let params = {
        id: this.editList[0].id,
        url: 'https://api.weixin.qq.com/wxa/release?access_token=ACCESS_TOKEN',
      };
      this.$confirm('确定发布小程序?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.success('小程序发布成功');
            } else if (data.error_code) {
              this.$message.error(data.error_massage);
            } else {
              this.$message.error(data.result.errmsg);
            }
            // 刷新数据
            this.getCodeInfo();
            this.getQrcode();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  watch: {
    active: {
      immediate: true,
      handler: function(val) {
        if (val == 1) {
          this.getTemplateList();
          this.getCodeInfo();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-textarea {
  textarea {
    min-height: 250px !important;
    width: 330px;
  }
}
/deep/ .zt-button {
  margin-left: 32px;
  margin-top: 40px;
}
/deep/ .el-select {
  width: 330px;
}
.qrcode-box {
  position: absolute;
  top: 89px;
  left: 568px;
  text-align: center;
  img {
    width: 268px;
    height: 268px;
  }
  span {
    font-size: 16px;
    margin-top: 10px;
    display: inline-block;
  }
}
</style>
